import React, { useState, useRef } from 'react';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { Typeahead } from 'react-bootstrap-typeahead';
import { toast } from 'react-toastify';

// Validation schema
const validationSchema = Yup.object({
  title: Yup.string().required('Title is required'),
  order: Yup.number().required('Order is required').min(1, 'Order must be at least 1'),
});

// Custom input component
const CustomInput = ({ field, form, ...props }) => {
  const hasError = form.touched[field.name] && form.errors[field.name];

  return (
    <div className={props.parentClass || 'form-group'}>
      <input
        {...field}
        {...props}
        className={`${props.className || 'form-control'} ${hasError ? 'error' : ''}`}
      />
      {hasError && (
        <div className="error-message" style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>
          {form.errors[field.name]}
        </div>
      )}
    </div>
  );
};

const CreateInterview = ({
  currentPiece,
  artistInfo,
  piecesInfo,
  pieceInterviews,
  onCreate,
  onDelete,
  onEdit,
  getAwsKey,
  accessMode,
  isCreating,
  triggerGetPiece
}) => {
  const [state, setState] = useState({
    audio_file: '',
    audio: '',
    order: '',
    file: {},
    awsKeys: {},
    disableUpload: false,
    audioUploaded: false,
    isUploading: false,
    interviewInputOn: false,
    interviewInputEditOn: false,
    title: '',
    artist: [],
    showFollowing: false,
    InterviewToEdit: null,
  });

  // Form ref for Formik
  const formikRef = useRef();

  const onChangeSetToState = (stateKey) => (e) => {
    let updates = {
      [stateKey]: e.currentTarget.value.trim(),
    };
    if (['audio_file'].includes(stateKey)) {
      updates.disableUpload = true;
    }
    setState(prev => ({ ...prev, ...updates }));
  };

  const onSubmit = async (values, { resetForm }) => {
    const { audio_file: audio, title, order } = values;
    const { artist } = state;
    const piece_id = currentPiece.id;

    if (!artist || !artist.length) {
      toast.error('Please select an artist');
      return;
    }

    await onCreate({
      audio: state.audio_file || audio,
      title,
      artist: artist[0].name,
      order,
      piece_id
    });

    // Reset form and state
    resetForm();
    setState({
      audio_file: '',
      audio: '',
      order: '',
      file: {},
      awsKeys: {},
      disableUpload: false,
      audioUploaded: false,
      isUploading: false,
      title: '',
      artist: [],
      interviewInputOn: false,
      interviewInputEditOn: false,
      InterviewToEdit: null,
    });

    try {
      document.getElementById('uploadPieceInterview').value = null;
    } catch (e) { }
  };

  const onFileChange = async (eve) => {
    setState(prev => ({
      ...prev,
      audioUploaded: false,
      disableUpload: false,
    }));

    const file = eve.target.files[0];
    const fileName = file.name.replace(/ /g, '_');
    const awsKeys = await getAwsKey({ key: `pieces/interviews/videos/${fileName}` });

    setState(prev => ({
      ...prev,
      file,
      audio_file: `${awsKeys.action}${awsKeys.key}`,
      awsKeys,
      disableUpload: true,
    }));

    if (state.InterviewToEdit) {
      var AudioFile = state.InterviewToEdit;
      AudioFile['audio'] = `${awsKeys.action}${awsKeys.key}`;
      setState(prev => ({
        ...prev,
        InterviewToEdit: AudioFile,
      }));
    }
  };

  const uploadAudio = (label) => async (eve) => {
    eve.preventDefault();

    if (label === 'editInterview') {
      if (Object.keys(state.awsKeys).length) {
        var form = document.getElementById('uploadInterviewAudioEdit');
        var data = new FormData(form);
      }
    } else {
      if (Object.keys(state.awsKeys).length) {
        var form = document.getElementById('uploadInterviewAudio');
        var data = new FormData(form);
      }
    }

    try {
      setState(prev => ({ ...prev, isUploading: true }));

      if (Object.keys(state.awsKeys).length) {
        await fetch(state.awsKeys.action, { method: 'POST', body: data });
        toast.success('Audio uploaded successfully.');
      }

      setState(prev => ({ ...prev, audioUploaded: true }));

      if (label === 'editInterview') {
        editInterview();
      } else {
        // Trigger form submission through Formik
        if (formikRef.current) {
          formikRef.current.handleSubmit();
        }
      }
    } catch (error) {
      toast.error('Something went wrong while uploading video.');
    } finally {
      setState(prev => ({ ...prev, isUploading: false }));
    }
  };

  const editInterview = async () => {
    let interview = { ...state.InterviewToEdit };
    interview.artist = interview.artist[0].name;

    await onEdit(interview, pieceInterviews[state.showFollowing]);
    setState(prev => ({
      ...prev,
      instrument_id: '',
      audio_file: '',
      audio: '',
      order: 1,
      file: {},
      awsKeys: {},
      disableUpload: false,
      instrument: null,
      audioUploaded: false,
      isUploading: false,
      title: '',
      showFollowing: false,
      interviewInputOn: false,
      interviewInputEditOn: false,
    }));

    triggerGetPiece();
  };

  const handleDelete = async (interview) => {
    await onDelete(interview);
  };

  const Show = (i) => {
    const InterviewToEditArray = pieceInterviews.filter((interview, id) => {
      if (id === i) {
        return interview;
      }
    });
    const InterviewToEditObject = { ...InterviewToEditArray[0] };
    InterviewToEditObject.artist = piecesInfo.members.filter(({ name }) => name === InterviewToEditObject.artist);

    setState(prev => ({
      ...prev,
      showFollowing: i,
      InterviewToEdit: JSON.parse(JSON.stringify(InterviewToEditObject)),
    }));
  };

  const handleStateChange = (key, val) => (e) => {
    e.stopPropagation();
    let updates = { [key]: val };
    if (['interviewInputEditOn', 'interviewInputOn'].includes(key)) {
      updates['audio_file'] = '';
      updates['awsKeys'] = {};
    }
    setState(prev => ({ ...prev, ...updates }));
  };

  const handleEditStateChange = (key, value) => {
    let Interview = state.InterviewToEdit;
    Interview[key] = value;
    setState(prev => ({
      ...prev,
      InterviewToEdit: Interview,
    }));
  };

  const getPieceInterviews = () => {
    const { awsKeys, disableUpload, interviewInputEditOn } = state;

    return pieceInterviews.map((interview, i) => {
      return (
        <div className="instrument-list" key={interview.id}>
          {accessMode === 'edit' && (
            <div className="row">
              <span
                style={{ display: 'inline-block', float: 'right', color: 'red' }}
                className="glyphicon glyphicon-remove-circle"
                aria-hidden="true"
                onClick={() => handleDelete(interview)}
              />
              <span
                style={{ display: 'inline-block', float: 'right', marginRight: '10px', color: 'green' }}
                className="glyphicon glyphicon-edit"
                aria-hidden="true"
                onClick={() => Show(i)}
              />
            </div>
          )}

          {state.showFollowing === i && (
            <div>
              <div className="row">
                <div className="col-md-3">
                  <label>Title</label>
                </div>
                <div className="col-md-9">
                  <input
                    name="title"
                    placeholder="Title"
                    type="text"
                    value={state.InterviewToEdit.title}
                    onChange={(e) => handleEditStateChange('title', e.target.value)}
                    className="form-control"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-3">
                  <label>Artist</label>
                </div>
                <div className="col-md-9">
                  <Typeahead
                    onChange={(selected) => handleEditStateChange('artist', selected)}
                    labelKey="name"
                    options={piecesInfo.members}
                    selected={state.InterviewToEdit.artist}
                    className={`form-group ${accessMode === 'view' ? 'disabled' : ''}`}
                    placeholder="Artist"
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-3">
                  <label>Order</label>
                </div>
                <div className="col-md-9">
                  <input
                    name="order"
                    placeholder="Order"
                    type="number"
                    value={state.InterviewToEdit.order}
                    onChange={(e) => handleEditStateChange('order', Number(e.target.value))}
                    className="form-control"
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-3">
                  <label>Video File</label>
                </div>
                <div className="col-md-9 radio-part">
                  <div className="currentFile">{state.InterviewToEdit.audio}</div>

                  <div className="radio-selection row">
                    <div className="col-md-4">
                      <input
                        type="radio"
                        id="linkTypeVideoEdit"
                        name="videoTypeEdit"
                        checked={!interviewInputEditOn}
                        onChange={handleStateChange('interviewInputEditOn', false)}
                      />
                      &nbsp;
                      <label htmlFor="linkTypeVideoEdit">Link</label>
                    </div>
                    <div className="col-md-4">
                      <input
                        type="radio"
                        id="uploadTypeVideoEdit"
                        name="videoTypeEdit"
                        checked={interviewInputEditOn}
                        onChange={handleStateChange('interviewInputEditOn', true)}
                      />
                      &nbsp;
                      <label htmlFor="uploadTypeVideoEdit">Upload</label>
                    </div>
                  </div>

                  {interviewInputEditOn ? (
                    <form id="uploadInterviewAudioEdit" method="post" encType="multipart/form-data">
                      <input type="hidden" name="key" value={awsKeys.key || 'NA'} />
                      <input type="hidden" name="acl" value={awsKeys.acl || 'NA'} />
                      <input type="hidden" name="X-Amz-Credential" value={awsKeys['x-amz-credential'] || 'NA'} />
                      <input type="hidden" name="X-Amz-Algorithm" value={awsKeys['x-amz-algorithm'] || 'NA'} />
                      <input type="hidden" name="X-Amz-Date" value={awsKeys['x-amz-date'] || 'NA'} />
                      <input type="hidden" name="Policy" value={awsKeys.policy || 'NA'} />
                      <input type="hidden" name="X-Amz-Signature" value={awsKeys['x-amz-signature'] || 'NA'} />
                      <input id="uploadPieceInterview" type="file" name="file" onChange={onFileChange} />
                    </form>
                  ) : (
                    <input
                      name="video"
                      placeholder="Video File"
                      value={state.InterviewToEdit.audio}
                      onChange={(e) => handleEditStateChange('audio', e.target.value)}
                      className={`form-control ${accessMode === 'view' ? 'disabled' : ''}`}
                      parentClass="form-group"
                    />
                  )}
                </div>
              </div>

              <div className="editButtons">
                <button
                  type="submit"
                  name="submit"
                  className="cus-btn-primary btn-sm submitButton"
                  style={{ margin: '10px 10px 10px 10px' }}
                  onClick={uploadAudio('editInterview')}
                >
                  {isCreating || state.isUploading ? <span className="spinner" /> : <span>Save</span>}
                </button>
                <button
                  type="button"
                  name="button"
                  className="cus-btn-danger btn-sm submitButton"
                  style={{ margin: '10px 10px 10px 10px' }}
                  onClick={() => {
                    setState(prev => ({
                      ...prev,
                      showFollowing: false,
                      InterviewToEdit: null,
                    }));
                  }}
                >
                  {isCreating || state.isUploading ? <span className="spinner" /> : <span>Cancel</span>}
                </button>
              </div>
              <hr />
            </div>
          )}
          {state.showFollowing !== i && (
            <div>
              <div className="row">
                <div className="col-md-3">
                  <label>Title</label>
                </div>
                <div className="col-md-9">{interview.title}</div>
              </div>
              <div className="row">
                <div className="col-md-3">
                  <label>Artist</label>
                </div>
                <div className="col-md-9">{interview.artist}</div>
              </div>
              <div className="row">
                <div className="col-md-3">
                  <label>Order</label>
                </div>
                <div className="col-md-9">{interview.order}</div>
              </div>
              <div className="row">
                <div className="col-md-3">
                  <label>Video File</label>
                </div>
                <div className="col-md-9">{interview.audio}</div>
              </div>
              <hr />
            </div>
          )}
        </div>
      );
    });
  };

  const { awsKeys, disableUpload, interviewInputOn } = state;

  return (
    <section className="well create-instrument">
      {getPieceInterviews()}

      {accessMode === 'edit' && (
        <Formik
          ref={formikRef}
          initialValues={{
            title: '',
            order: 1,
          }}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          {({ values, setFieldValue, isSubmitting }) => (
            <Form>
              <div className="row">
                <div className="col-md-3">
                  <label>Title</label>
                </div>
                <div className="col-md-9">
                  <Field
                    name="title"
                    placeholder="Title"
                    component={CustomInput}
                    type="text"
                    className="form-control"
                    parentClass="form-group"
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-3">
                  <label>Artist</label>
                </div>
                <div className="col-md-9">
                  <Typeahead
                    onChange={(selected) => {
                      setState(prev => ({ ...prev, artist: selected }));
                    }}
                    labelKey="name"
                    options={piecesInfo.members}
                    selected={state.artist}
                    className={`form-group ${accessMode === 'view' ? 'disabled' : ''}`}
                    placeholder="Artist"
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-3">
                  <label>Order</label>
                </div>
                <div className="col-md-9">
                  <Field
                    name="order"
                    placeholder="Order"
                    component={CustomInput}
                    type="number"
                    className="form-control"
                    parentClass="form-group"
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-3">
                  <label>Audio</label>
                </div>
                <div className="col-md-9 radio-part">
                  <div className="radio-selection row">
                    <div className="col-md-4">
                      <input
                        type="radio"
                        id="linkTypeVideo"
                        name="videoType"
                        checked={!interviewInputOn}
                        onChange={handleStateChange('interviewInputOn', false)}
                      />
                      &nbsp;
                      <label htmlFor="linkTypeVideo">Link</label>
                    </div>
                    <div className="col-md-4">
                      <input
                        type="radio"
                        id="uploadTypeVideo"
                        name="videoType"
                        checked={interviewInputOn}
                        onChange={handleStateChange('interviewInputOn', true)}
                      />
                      &nbsp;
                      <label htmlFor="uploadTypeVideo">Upload</label>
                    </div>
                  </div>

                  {interviewInputOn ? (
                    <form id="uploadInterviewAudio" method="post" encType="multipart/form-data">
                      <input type="hidden" name="key" value={awsKeys.key || 'NA'} />
                      <input type="hidden" name="acl" value={awsKeys.acl || 'NA'} />
                      <input type="hidden" name="X-Amz-Credential" value={awsKeys['x-amz-credential'] || 'NA'} />
                      <input type="hidden" name="X-Amz-Algorithm" value={awsKeys['x-amz-algorithm'] || 'NA'} />
                      <input type="hidden" name="X-Amz-Date" value={awsKeys['x-amz-date'] || 'NA'} />
                      <input type="hidden" name="Policy" value={awsKeys.policy || 'NA'} />
                      <input type="hidden" name="X-Amz-Signature" value={awsKeys['x-amz-signature'] || 'NA'} />
                      <input id="uploadPieceInterview" type="file" name="file" onChange={onFileChange} />
                    </form>
                  ) : (
                    <input
                      name="video"
                      placeholder="Video File"
                      value={state.audio_file}
                      onChange={onChangeSetToState('audio_file')}
                      className={`form-control ${accessMode === 'view' ? 'disabled' : ''}`}
                      parentClass="form-group"
                    />
                  )}
                </div>
              </div>

              <button
                type="button"
                name="submit"
                onClick={uploadAudio('newInterview')}
                className="cus-btn-primary btn-block btn-lg submitButton"
                disabled={isCreating || !(disableUpload && state.artist && values.title)}
              >
                {isCreating || state.isUploading ? <span className="spinner" /> : <span>Add Interview</span>}
              </button>
            </Form>
          )}
        </Formik>
      )}
    </section>
  );
};

export default CreateInterview;
